<div class="app-container">
  <!-- Loading State -->
  @if (auth.isLoading$ | async) {
    <div class="loading-state">
      <div class="loading-text">Loading...</div>
    </div>
  }

  <!-- Error State -->
  @if (auth.error$ | async; as error) {
    <div class="error-state">
      <div class="error-title">Oops!</div>
      <div class="error-message">Something went wrong</div>
      <div class="error-sub-message">{{ error.message }}</div>
    </div>
  }

  <!-- Main Content -->
  @if (!(auth.isLoading$ | async) && !(auth.error$ | async)) {
    <!-- Authenticated State -->
    @if (auth.isAuthenticated$ | async) {
      <!-- Verifica anche che l'utente sia autorizzato prima di mostrare il contenuto principale -->
      @if (authHub.isAuthorized$ | async) {
        <header class="app-header">
          <div class="header-content">
            <div class="header-left">
              <h1>{{ title }}</h1>
              <p>Version {{ version }}</p>
            </div>
            <div class="auth-section">
              <app-profile />
              <app-logout-button />
          </div>
        </div>
      </header>
      
      <!-- Menu orizzontale -->
      <nav class="top-nav">
        <ul class="top-nav-menu">
          <li>
            <a routerLink="activations" routerLinkActive="active" class="menu-item">
              <span class="menu-text">Activations</span>
            </a>
          </li>
          <!-- <li>
            <a routerLink="activate" routerLinkActive="active" class="menu-item">
              <span class="menu-text">Add customer</span>
            </a>
          </li> -->
          <!-- <li>
            <a routerLink="tasks" routerLinkActive="active" class="menu-item"> 
              <span class="menu-text">Issue tickets</span>
            </a>
          </li> -->
          <li>
            <a routerLink="system-status" routerLinkActive="active" class="menu-item">
              <span class="menu-text">System status</span>
            </a>
          </li>
          <li>
            <a routerLink="create-issue-form" routerLinkActive="active" class="menu-item">
              <span class="menu-text">Report issue</span>
            </a>
          </li>
          <!-- <li>
            <a routerLink="add-feedback" routerLinkActive="active" class="menu-item">
              <span class="menu-text">Add client feedback</span>
            </a>
          </li> -->
        </ul>
      </nav>
      
      <!-- Contenuto principale -->
      <main class="main-content">
        <router-outlet />
      </main>
      } @else {
        <!-- Utente autenticato ma non autorizzato - mostra solo unauthorized -->
        <router-outlet />
      }
    } @else {
      <!-- Unauthenticated State - Login Screen -->
      <div class="login-container">
        <div class="login-card">
          <img 
            src="https://mediahub-dev.blinkoo.com/images/media-hub-logo-beta.svg" 
            alt="Blinkoo Logo" 
            class="auth0-logo"
          />
          <h1 class="login-title">{{ title }}</h1>
          <p class="login-subtitle">Get started by signing in to your account</p>
          <app-login-button />
        </div>
      </div>
    }
  }
</div>
